const actions = {
  GET_USERS_EXPERIMENT_BEGIN: 'GET_USERS_EXPERIMENT_BEGIN',
  GET_USERS_EXPERIMENT_SUCCESS: 'GET_USERS_EXPERIMENT_SUCCESS',
  GET_USERS_EXPERIMENT_ERR: 'GET_USERS_EXPERIMENT_ERR',

  SET_USERS_EXPERIMENT_BEGIN: 'SET_USERS_EXPERIMENT_BEGIN',
  SET_USERS_EXPERIMENT_SUCCESS: 'SET_USERS_EXPERIMENT_SUCCESS',
  SET_USERS_EXPERIMENT_ERR: 'SET_USERS_EXPERIMENT_ERR',

  getUsersExperimentBegin: () => {
    return {
      type: actions.GET_USERS_EXPERIMENT_BEGIN,
    };
  },

  getUsersExperimentSuccess: data => {
    return {
      type: actions.GET_USERS_EXPERIMENT_SUCCESS,
      data,
    };
  },

  getUsersExperimentErr: err => {
    return {
      type: actions.GET_USERS_EXPERIMENT_ERR,
      err,
    };
  },

  setUsersExperimentBegin: () => {
    return {
      type: actions.SET_USERS_EXPERIMENT_BEGIN,
    };
  },

  setUsersExperimentSuccess: data => {
    return {
      type: actions.SET_USERS_EXPERIMENT_SUCCESS,
      data,
    };
  },

  setUsersExperimentErr: err => {
    return {
      type: actions.SET_USERS_EXPERIMENT_ERR,
      err,
    };
  },
};

export default actions;
